export enum KYCStatus {
  NotVerified = 'not_verified',
  InProgress = 'in_progress',
  Verified = 'verified',
  Started = 'started',
  ResubmissionRequested = 'resubmission_requested',
  Declined = 'declined',
}
